import { useQuery } from '@tanstack/react-query';
import { emailDomainsApi } from '../services';

/**
 * Hook para listar todos os dominios de email.
 *
 * @param params - Parametros opcionais de filtro (status, domain, etc.)
 * @returns Query com lista de dominios
 *
 * @example
 * ```tsx
 * const { data: domains, isLoading } = useEmailDomains();
 * ```
 */
export const useEmailDomains = (params?: Record<string, unknown>) => {
  return useQuery({
    queryKey: ['email-domains', params],
    queryFn: () => emailDomainsApi.getAll(params),
    staleTime: 30_000,
  });
};
